import { Bar } from 'react-chartjs-2';
import type { ChartOptions } from 'chart.js';

type BarDataset = {
    label: string;
    data: number[];
    backgroundColor?: string | string[];
    stack?: string;
    maxBarThickness?: number;
    minBarLength?: number;
};

type BarChartProps = {
    labels?: string[] | undefined;
    // 단일 데이터셋 간단 사용
    series?: number[] | undefined;
    title?: string;
    // 멀티 데이터셋(스택 등) 사용 시
    datasets?: BarDataset[];
    // 옵션 커스터마이즈
    options?: ChartOptions<'bar'>;
    height?: number;
};

const BarChart = ({ labels, series, title = '', datasets, options: optionsProp, height = 350 }: BarChartProps) => {
    const resolvedDatasets: BarDataset[] = datasets ?? [
        {
            label: title ?? [],
            data: series ?? [],
            backgroundColor: 'rgba(156, 22, 246, 0.6)',
            maxBarThickness: 40,
        },
    ];

    const data = {
        labels,
        datasets: resolvedDatasets,
    };

    const defaultOptions: ChartOptions<'bar'> = {
        plugins: {
            legend: { display: true, position: 'top', align: 'end' },
            title: { display: !!title, text: title },
            tooltip: { intersect: false, mode: 'index' },
        },
        scales: {
            x: { stacked: true, grid: { display: false } },
            y: { beginAtZero: true, stacked: true },
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    const options: ChartOptions<'bar'> = {
        ...defaultOptions,
        ...optionsProp,
        plugins: {
            ...defaultOptions.plugins,
            ...(optionsProp?.plugins ?? {}),
        },
        scales: {
            ...defaultOptions.scales,
            ...(optionsProp?.scales ?? {}),
        },
    };

    return (
        <div style={{ height }}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default BarChart;
